import { SvgProps } from "@/utils/types";

export const Tomato = ({
  primaryColor = "#06B68F",
  secondaryColor = "#D4DF65",
  outlineColor = "#0E5654",
  className,
}: SvgProps) => {
  return (
    <svg
      width="49"
      height="51"
      viewBox="0 0 49 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_5_917)">
        <path
          d="M34.34 13.55C31.38 16.51 27.46 15.62 27.46 15.62C27.46 15.62 26.57 11.7 29.53 8.74C32.49 5.78 36.41 6.67 36.41 6.67C36.41 6.67 37.3 10.59 34.34 13.55Z"
          fill={secondaryColor}
        />
        <path
          d="M28.86 17.91C27.78 17.91 27.06 17.75 26.98 17.73L25.65 17.43L25.35 16.1C25.3 15.89 24.23 10.96 28 7.19999C31.76 3.42999 36.69 4.50999 36.9 4.54999L38.23 4.84999L38.53 6.17999C38.58 6.38999 39.65 11.32 35.88 15.08C33.51 17.45 30.68 17.9 28.86 17.9V17.91ZM34.33 8.74999C33.37 8.84999 32.12 9.21999 31.07 10.27C30.02 11.32 29.65 12.57 29.55 13.54C30.51 13.44 31.76 13.07 32.81 12.02C33.86 10.97 34.23 9.71999 34.33 8.74999Z"
          fill={outlineColor}
        />
        <path
          d="M13.8701 13.98C10.9101 11.02 11.8001 7.1 11.8001 7.1C11.8001 7.1 15.7201 6.21 18.6801 9.17C21.6401 12.13 20.7501 16.05 20.7501 16.05C20.7501 16.05 16.8301 16.94 13.8701 13.98Z"
          fill={secondaryColor}
        />
        <path
          d="M19.36 18.34C17.54 18.34 14.71 17.89 12.34 15.52C8.57004 11.75 9.64004 6.83 9.69004 6.62L9.99004 5.29L11.32 4.99C11.53 4.94 16.46 3.87 20.22 7.64C23.99 11.41 22.92 16.33 22.87 16.54L22.57 17.87L21.24 18.17C21.16 18.19 20.44 18.35 19.36 18.35V18.34ZM13.89 9.18C13.99 10.14 14.36 11.39 15.42 12.45C16.47 13.5 17.72 13.87 18.69 13.97C18.59 13.01 18.22 11.76 17.16 10.71C16.1 9.65 14.86 9.29 13.89 9.19V9.18Z"
          fill={outlineColor}
        />
        <path
          d="M27.94 8.89C27.94 13.08 24.53 15.22 24.53 15.22C24.53 15.22 21.12 13.08 21.12 8.89C21.12 4.7 24.53 2.56 24.53 2.56C24.53 2.56 27.94 4.7 27.94 8.89Z"
          fill={secondaryColor}
        />
        <path
          d="M24.53 17.79L23.37 17.06C23.19 16.95 18.95 14.22 18.95 8.89C18.95 3.56 23.1899 0.84 23.3799 0.73L24.54 0L25.7 0.73C25.88 0.84 30.12 3.57 30.12 8.9C30.12 14.23 25.88 16.95 25.7 17.07L24.54 17.8L24.53 17.79ZM24.53 5.51C23.92 6.27 23.2999 7.4 23.2999 8.9C23.2999 10.4 23.92 11.53 24.53 12.29C25.14 11.54 25.76 10.4 25.76 8.9C25.76 7.4 25.14 6.27 24.53 5.51Z"
          fill={outlineColor}
        />
        <path
          d="M46.26 31.08C46.26 40.9 36.34 48.86 24.11 48.86C11.88 48.86 1.95996 40.9 1.95996 31.08C1.95996 25.44 5.23996 20.41 10.35 17.15C14.13 14.74 18.91 16.2 24.11 16.2C29.31 16.2 34.1 14.74 37.88 17.15C42.99 20.41 46.27 25.44 46.27 31.08H46.26Z"
          fill={primaryColor}
        />
        <path
          d="M24.11 50.82C10.81 50.82 0 41.97 0 31.08C0 24.94 3.39 19.26 9.29 15.5C12.56 13.42 16.32 13.72 19.97 14.02C21.32 14.13 22.72 14.24 24.11 14.24C25.5 14.24 26.9 14.13 28.25 14.02C31.89 13.72 35.66 13.42 38.93 15.5C44.83 19.26 48.22 24.94 48.22 31.08C48.22 41.96 37.41 50.82 24.11 50.82ZM16.05 17.72C14.28 17.72 12.71 17.96 11.4 18.8C6.65 21.83 3.92 26.31 3.92 31.08C3.92 39.81 12.98 46.9 24.11 46.9C35.24 46.9 44.3 39.8 44.3 31.08C44.3 26.31 41.57 21.83 36.82 18.8C34.66 17.43 31.84 17.65 28.56 17.92C27.13 18.04 25.65 18.16 24.1 18.16C22.55 18.16 21.07 18.04 19.64 17.92C18.37 17.82 17.16 17.72 16.04 17.72H16.05Z"
          fill={outlineColor}
        />
        <path
          d="M10.4 38.68C11.4604 38.68 12.32 37.8204 12.32 36.76C12.32 35.6996 11.4604 34.84 10.4 34.84C9.33959 34.84 8.47998 35.6996 8.47998 36.76C8.47998 37.8204 9.33959 38.68 10.4 38.68Z"
          fill={outlineColor}
        />
        <path
          d="M9.09 33.46C9.31 33.35 9.57 33.25 9.88 33.19C10.31 33.1 10.58 32.67 10.47 32.25C10.17 31.12 9.77 28.9 10.06 25.56C10.14 24.63 8.82 24.33 8.52 25.22C8.25 26.04 8.02 27.01 7.88 28.12C7.72 29.47 7.7 31.05 7.91 32.85C7.98 33.41 8.58 33.71 9.08 33.46H9.09Z"
          fill={outlineColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_5_917">
          <rect width="48.21" height="50.82" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
